<template>
    <div class="main-content people-detail " v-cloak>
        <div class="container" style="overflow:hidden;">
            <div class="" v-if="!person_save_btn_loading">
                <div class="form-container">
                    <div class="form-wrapper">
                        <div class="form-row">
                            <div class="form-hor">
                                <div class="people-item-icon-wrapper">
                                    <div class="has-logo" v-if="person.avatar_url" @click="upload_logo">
                                        <div
                                            class="person-logo"
                                            :style="{
                                                backgroundImage: `url('${settings.api_url +
                                                    '/resource/avatar/' +
                                                    person.id}')`
                                            }"
                                        ></div>
                                    </div>
                                    <div v-else>
                                        <div
                                            @click="upload_logo"
                                            class="people-item-icon-container"
                                            v-if="person.gender"
                                        >
                                            <span
                                                :class="{
                                                    'icon-man': person.gender === 'man',
                                                    'icon-woman': person.gender === 'woman'
                                                }"
                                            ></span>
                                        </div>
                                        <div @click="upload_logo" class="people-item-icon-container" v-else>
                                            <span :class="{ 'icon-man': true }"></span>
                                        </div>
                                    </div>
                                </div>
                                <input
                                    style="display:none;"
                                    ref="avatar"
                                    type="file"
                                    accept="image/x-png,image/jpeg"
                                    @change="upload_image($event)"
                                />

                                <dropdown
                                    @selected="set_drop_value"
                                    :value="person.gender"
                                    name="gender"
                                    :unsort="true"
                                    label="Gender"
                                    :options="person_gender_options"
                                ></dropdown>
                            </div>
                            <div class="form-hor form-hor-next">
                                <custom-input
                                    @change="set_value"
                                    input_type="text"
                                    :invalid="errors && errors.includes('first_name')"
                                    :value="person.first_name"
                                    limit="60"
                                    :required="true"
                                    hint="Hint! Max 60 characters"
                                    :name_capitalization="true"
                                    error_msg="Error! This field is mandatory"
                                    name="first_name"
                                    label="First name"
                                ></custom-input>
                                <custom-input
                                    @change="set_value"
                                    input_type="text"
                                    :invalid="errors && errors.includes('last_name')"
                                    :value="person.last_name"
                                    :required="person.age_group === 'adult' ? true : false"
                                    limit="60"
                                    hint="Hint! Max 60 characters"
                                    :capitalize="true"
                                    error_msg="Error! This field is mandatory"
                                    name="last_name"
                                    label="Last name"
                                ></custom-input>
                                <custom-input
                                    @change="set_value"
                                    datepicker="true"
                                    icon_class="icon icon-calendar"
                                    input_type="datepicker"
                                    allow_input="true"
                                    format="dd.mm.yyyy"
                                    error_msg="Error! This field is mandatory"
                                    :invalid="errors && errors.includes('birthday')"
                                    :value="person.birthday"
                                    name="birthday"
                                    show_reset="true"
                                    type="text"
                                    label="Birthday"
                                ></custom-input>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-hor">
                                <custom-input
                                    @change="set_value"
                                    input_type="text"
                                    :invalid="errors && errors.includes('phone')"
                                    :value="person.phone"
                                    limit="20"
                                    icon_class="icon icon-phone icon-inp"
                                    hint="Hint! Max 20 characters"
                                    error_msg="Error! Phone number is not valid"
                                    name="phone"
                                    label="Phone"
                                ></custom-input>
                                <custom-input
                                    @change="set_value"
                                    input_type="email"
                                    icon_class="icon icon-envelope icon-inp"
                                    :invalid="errors && errors.includes('email')"
                                    :value="person.email"
                                    limit="60"
                                    hint="Hint! Max 60 characters"
                                    error_msg="Error! E-mail is not valid"
                                    name="email"
                                    label="Email"
                                ></custom-input>
                                <custom-input
                                    @change="set_value"
                                    :invalid="errors && errors.includes('facebook')"
                                    :value="person.facebook"
                                    limit="60"
                                    icon_class="icon icon-fb icon-inp"
                                    hint="Hint! Max 60 characters"
                                    error_msg="Error! This field is mandatory"
                                    name="facebook"
                                    label="Facebook"
                                ></custom-input>
                            </div>
                        </div>
                    </div>
                    <div class="form-wrapper">
                        <div class="form-row">
                            <div class="form-hor ">
                                <dropdown
                                    @selected="set_drop_value"
                                    :value="person.group"
                                    name="group"
                                    label="Set group"
                                    :options="person_group_options"
                                ></dropdown>
                            </div>
                            <div class="form-hor form-hor-2"></div>
                        </div>
                    </div>
                </div>
                <kids-additional-info-block></kids-additional-info-block>
                <div class="form participating-list" v-if="person.events && person.events.length > 0">
                    <div class="events-group-header">
                        <div class="events-group-header-icon"><span>P</span></div>
                        Participating
                    </div>
                    <participating-row
                        v-for="(person_event, inx) in person.events"
                        :person_event="person_event"
                        :key="inx"
                    ></participating-row>
                </div>
            </div>
            <div v-else>
                <div class="loading-container">
                    <div id="loading"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import dropdown from "@/components/pages/dropdown.vue";
import customInput from "@/components/pages/custom-input.vue";
import customTextarea from "@/components/pages/custom-textarea.vue";
import kidsAdditionalInfoBlock from "./kids-additional-info-block.vue";
import participatingRow from "./participating-row.vue";
import axios from "axios";
import settings from "@/settings";
import router from "@/router";
import moment from "moment";

export default {
    name: "people-edit",

    components: { dropdown, customInput, customTextarea, kidsAdditionalInfoBlock, participatingRow },
    computed: {
        ...mapState("StorePeople", [
            "person",
            "kid",
            "person_group_options",
            "person_gender_options",
            "person_save_btn_loading",
            "persons_events",
            "errors",
            "kid_errors"
        ])
    },
    data() {
        return {
            settings: settings
        };
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.set_empty_person();
            if (to.params && to.params.id) {
                vm.get_current_person(to.params.id);
                vm.get_person_events(to.params.id);
            }
            next();
        });
    },
    mounted() {},

    methods: {
        ...mapMutations("StorePeople", [
            "clear_person",
            "set_btn_mode",
            "update_field",
            "add_kid",
            "set_person_kid",
            "validate_kid_fields",
            "set_save_btn_state"
        ]),
        ...mapActions(["get_logged_in_user"]),
        ...mapMutations("StorePeople", ["update_field", "clear_person", "clear_errors", "clear_kid_errors"]),
        ...mapActions("StorePeople", ["get_person", "upload_person_logo", "get_person_events"]),
        set_drop_value(payload) {
            this.check_validation_show_btn();
            this.update_field({
                prop_name: payload.name,
                prop_value: payload.value
            });
        },
        set_value(args) {
            if (this.person[args.prop_name] !== args.prop_value) {
                this.check_validation_show_btn();
            }
            this.update_field(args);
        },

        check_validation_show_btn() {
            if (this.validate_person()) {
                this.set_btn_mode(true);
            } else {
                this.set_btn_mode(false);
            }
            this.set_save_btn_state(true);
        },
        set_empty_person() {
            this.clear_errors();
            this.clear_person();
        },
        upload_image(event) {
            let data = {
                file: event.target.files[0],
                name: "avatar_logo",
                person_id: this.person.id,
                action: "upload_logo"
            };
            this.upload_person_logo(data);
            window.location.reload();
        },
        upload_logo() {
            this.$refs.avatar.click();
        },
        get_current_person(person_id) {
            this.get_person(person_id);
        },

        validate_person() {
            if (this.person.age_group === "adult") {
                if (
                    this.person.first_name &&
                    this.person.first_name.trim() &&
                    this.person.last_name &&
                    this.person.last_name.trim()
                ) {
                    return true;
                } else {
                    return false;
                }
            } else {
                if (this.person.first_name && this.person.first_name.trim()) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }
};
</script>

<style scoped>
@media (max-width: 82rem) {
    .main-content {
        height: 60vh;
        overflow: auto;
    }
}
</style>
